export default __webpack_public_path__ + "static/media/keto-chocolate-bar.529b811c.png";